import PropTypes from 'prop-types'
import React from 'react'
import _replace from 'lodash/replace'
import { useSelector } from 'react-redux'
import { selectTaxMessaging } from 'services/user-account/selectors'
import { selectStaticTextByKey } from 'services/static-text/selectors'
import { PLAN_GRID_CURRENCY_KEY as storeKey } from './plan-grid-currency-key'

const PlanGridCurrencyPropTypes = {
  currencyIso: PropTypes.string.isRequired,
  className: PropTypes.string,
}

/**
 * @type {React.FC<PropTypes.InferProps<PlanGridCurrencyPropTypes>>}
 * @returns {React.ReactElement}
 * */
export const PlanGridCurrency = ({ currencyIso, className = '' }) => {
  const staticText = useSelector(selectStaticTextByKey(storeKey))
  const isTaxMessageShown = useSelector(selectTaxMessaging)

  return (
    <div className={`plan-grid-currency ${className}`}>
      {
        // eslint-disable-next-line no-template-curly-in-string
        _replace(staticText.get('currency'), '${ currencyIso }', currencyIso)
      }
      {isTaxMessageShown ? ` (${staticText.get('plusTax')})` : null}
    </div>
  )
}

PlanGridCurrency.propTypes = PlanGridCurrencyPropTypes

export default PlanGridCurrency
